import React from "react";
import styled from "styled-components";

// Wraps every Nexus report so they stay usable on phones and tablets: filter
// controls take the full width, stat rows and KPI cards stack, tables scroll
// sideways inside their card and dialogs fit the screen. Desktop is untouched.

const Shell = styled.div`
  max-width: 100%;

  .ant-table-content,
  .ant-table-body {
    overflow-x: auto;
  }
  .ant-select,
  .ant-picker {
    max-width: 100%;
  }

  @media (max-width: 1023px) {
    .ant-modal {
      max-width: calc(100vw - 24px);
    }
  }

  @media (max-width: 767px) {
    overflow-x: hidden;

    .dropstyle,
    .dropstyle1 {
      width: 100% !important;
      margin-top: 0 !important;
    }
    .dropstyle .ant-select,
    .dropstyle1 .ant-picker,
    .dropstyle1 .ant-space,
    .Custom .ant-select,
    .Custom .ant-picker {
      width: 100% !important;
    }
    .total,
    .Custom,
    .header-container {
      flex-wrap: wrap;
      gap: 8px;
    }
    .Custom {
      width: 100%;
    }
    .ant-card-body {
      padding: 12px;
    }

    /* overview strips (stat boxes separated by dividers) */
    .nexus-stat-bar {
      flex-direction: column;
      align-items: stretch !important;
      padding: 12px 16px !important;
      gap: 12px;
    }
    .nexus-stat-divider,
    .vr {
      display: none !important;
    }

    /* KPI alert cards */
    .customizable_container_forkpi {
      flex-direction: column;
      gap: 12px;
      margin-top: 12px;
    }
    .customizable_container {
      width: 100% !important;
      height: auto !important;
      min-height: 100px;
      margin-bottom: 0 !important;
    }

    /* dialogs */
    .ant-modal {
      width: calc(100vw - 16px) !important;
      max-width: calc(100vw - 16px);
      margin: 8px auto;
      top: 8px;
    }
    .ant-modal-body {
      max-height: calc(100vh - 160px);
      overflow-y: auto;
    }
    .ant-modal-body .ant-col {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .ant-pagination {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;

export const withNexusReportShell = (Component) => {
  const Wrapped = (props) => (
    <Shell className="nexus-report-shell">
      <Component {...props} />
    </Shell>
  );
  Wrapped.displayName = `NexusReportShell(${Component.displayName || Component.name || "Report"})`;
  return Wrapped;
};

export default withNexusReportShell;
